import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SectionsProvider } from './Shared/Context/SectionContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
        <SectionsProvider>
        <App />
        </SectionsProvider>
  </React.StrictMode>
);


reportWebVitals();
